import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { fuseAnimations } from '../../../core/animations'
import { DashboardService } from './service/dashboard.service'
import { TellowConstants } from '../enums/TellowConstants'
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service'
import { dutch } from './i18n/nl'
import { Router } from '@angular/router'

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class DashboardComponent implements OnInit {
  widgets: any[]
  states = TellowConstants.getStatus()

  constructor(
    private dashboardService: DashboardService,
    private translationLoader: FuseTranslationLoaderService,
    private router: Router,
  ) {
    this.translationLoader.loadTranslations(dutch)
  }

  ngOnInit() {
    // this.dashboardService.userStates().subscribe(data => {
    //   data.forEach(item => {
    //     switch (item.status){
    //       case 1:
    //         item['status_name'] = 'DASHBOARD.PROSPECT';
    //         item['color'] = 'light-blue-fg ';
    //         break;
    //       case 2:
    //         item['status_name'] = 'DASHBOARD.ACTIVE';
    //         item['color'] = 'blue-gray-fg';
    //         break;
    //       case 3:
    //         item['status_name'] = 'DASHBOARD.BLOCKED';
    //         item['color'] = 'red-fg';
    //         break;
    //       case 4:
    //         item['status_name'] = 'DASHBOARD.INVITED';
    //         item['color'] = 'orange-fg';
    //         break;
    //     }
    //   });
    //   this.widgets = data;
    // });
  }
  getUsers(widget) {
    this.router.navigate(['users/status/' + widget.status])
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/dashboard/dashboard.component.ts